export default __webpack_public_path__ + "static/media/Comp 2_00035.54df54be.png";